import React from "react";
import { useTranslation } from "react-i18next";
import "./profile.css"

export default function Profile() {
  const { t } = useTranslation(["common", "profile"]);

  return <div className="maincontent">{t("profile")}</div>;
}
